import DirectSelect from '@mapbox/mapbox-gl-draw/src/modes/direct_select';
import { MAP_MODES } from './modes';
import * as CommonSelectors from '@mapbox/mapbox-gl-draw/src/lib/common_selectors';
import { isOfMetaType } from '@mapbox/mapbox-gl-draw/src/lib/common_selectors';
import * as Constants from '@mapbox/mapbox-gl-draw/src/constants';

const DirectSelectMode = { ...DirectSelect };

DirectSelectMode.startDragging = function (state: any, e: any) {
  // todo remove this, we should use the correct mode to avoid dragging
  if (!CommonSelectors.isVertex(e) && !isOfMetaType(Constants.meta.MIDPOINT)(e)) {
    return;
  }
  this.map?.dragPan.disable();
  state.canDragMove = true;
  state.dragMoveLocation = e.lngLat;
};

DirectSelectMode.onMidpoint = function (state, e) {
  this.startDragging(state, e);
  const about = e.featureTarget.properties;
  state.feature.addCoordinate(about.coord_path, about.lng, about.lat);
  this.fireUpdate();
  state.selectedCoordPaths = [about.coord_path];
};

DirectSelectMode.clickNoTarget = function () {
  this.changeMode(MAP_MODES.AUTO_DIRECT_SELECT);
};

DirectSelectMode.clickInactive = function () {
  this.changeMode(MAP_MODES.AUTO_DIRECT_SELECT);
};

DirectSelectMode.onTrash = function (state: any) {
  this.deleteFeature([state.featureId], { silent: true });
  this.clearSelectedFeatures();
  this.changeMode(MAP_MODES.AUTO_DIRECT_SELECT, {});
};

export default DirectSelectMode;
